export function stickySingleProduct() {
  document.addEventListener("DOMContentLoaded", function () {
    function openAccordion() {
      let acc = document.querySelector(".accordion-container");

      acc.classList.toggle("active");
      let panel = acc.nextElementSibling;
      panel.style.maxHeight = "50vh";
      panel.style.opacity = "1";
    }

    function updateHeight() {
      let appSmileLauncher = document.querySelector('.smile-launcher-frame-container.smile-launcher-border-radius-circular.show-sticky')
      const openPanelHeight = document.querySelector(".sticky-pdp-variant");
      if (openPanelHeight) {
        document.documentElement.style.setProperty("--sticky-product-open-height", `${openPanelHeight.offsetHeight}px`);
      }
      if (appSmileLauncher) {
        appSmileLauncher.classList.add("open-acc");
      }
    }

    let counter = 0;
    let openButtonAccordion = document.querySelector(".sticky-pdp-variant .product-form__submit");

    openButtonAccordion.addEventListener("click", function (e) {
      if (counter == 0) {
        e.preventDefault();
        openAccordion();
        setTimeout(() => {
          updateHeight();
        }, 150);
        counter = 1;
      }
    });
  });
       
  customElements.define(
    "sticky-product-form",
    class StickyProductForm extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.productForm = document.querySelector(".product-form__buttons");
        
        this.productStickyForm = document.querySelector(".sticky-pdp-variant");
        this.productFormBounds = {};

        this.updateStickyHeight();

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener("scroll", this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        window.removeEventListener("scroll", this.onScrollHandler);

        if (this.accordionObserver) {
          this.accordionObserver.disconnect();
        }
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.productFormBounds = entries[0].isIntersecting;
        });
        observer.observe(this.productForm);
      }

      onScroll() {
        this.productFormBounds || window.scrollY < 1000
          ? requestAnimationFrame(this.hide.bind(this))
          : requestAnimationFrame(this.reveal.bind(this));
      }

      hide() {
        if (
          this.productStickyForm.classList.contains(
            "product--sticky-form__active"
          )
        ) {
          this.productStickyForm.classList.remove(
            "product--sticky-form__active"
          );
          this.productStickyForm.classList.add(
            "product--sticky-form__inactive"
          );

          let appSmileLauncher = document.querySelector('.smile-launcher-frame-container.smile-launcher-border-radius-circular')
          if (appSmileLauncher) {
            appSmileLauncher.classList.remove("show-sticky");
          }
          const attentive_creative =
            document.getElementById("attentive_creative");
          if (attentive_creative) {
            attentive_creative.classList.remove("active-sticky");
          }
        }
      }

      reveal() {
        if (
          this.productStickyForm.classList.contains(
            "product--sticky-form__inactive"
          )
        ) {
          this.productStickyForm.classList.add("product--sticky-form__active");
          this.productStickyForm.classList.remove("product--sticky-form__inactive");

          let appSmileLauncher = document.querySelector('.smile-launcher-frame-container.smile-launcher-border-radius-circular')
          if (appSmileLauncher) {
            appSmileLauncher.classList.add("show-sticky");
          }
          const attentive_creative =
            document.getElementById("attentive_creative");
          if (attentive_creative) {
            attentive_creative.classList.add("active-sticky");
            attentive_creative.style.transition = "bottom 0.3s ease-in";
          }
        }
      }

      updateStickyHeight() {
        const heightStickyProduct = this.productStickyForm.offsetHeight;
        if (heightStickyProduct) {
          document.documentElement.style.setProperty("--sticky-product-height", `${heightStickyProduct}px`);
        }
      }
    }
  );
}
